import { AppContext } from "@/contextApi/AppProvider";
import { AppContextType } from "@/interFace/general";

import { useDispatch } from "react-redux";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import HeaderCartIcon from "@/svg/HeaderCartIcon";
import React, { useContext } from "react";
import MemoAuthMenuTwo from "./MemoAuthMenuTwo";
import Link from "next/link";
import { Routes } from "@/constants";

const MobileMenu = () => {
  const { toggleSideMenu, sideMenuOpen } = useContext(
    AppContext
  ) as AppContextType;

  const dispatch = useDispatch();
  const cartProducts = useSelector(
    (state: RootState) => state.cart.cartProducts
  );
  const uniqueProductIds = new Set();
  cartProducts?.forEach((product) => uniqueProductIds.add(product.id));
  const quantityProduct = uniqueProductIds?.size;

  return (
    <div className={sideMenuOpen ? "sidebar__area open" : "sidebar__area"}>
      <div className="sidebar__wrapper">
        <div className="sidebar__close">
          <button
            className="sidebar__close-btn"
            onClick={toggleSideMenu}
            id="sidebar__close-btn"
          >
            <span>
              <i className="fal fa-times"></i>
            </span>
            <span>X</span>
          </button>
        </div>
        <div className="sidebar__content">
          <div className="mm-menu">
            <ul>
              <MemoAuthMenuTwo />
              <Link href={Routes.CART}>
                <li style={{ color: "blue" }} onClick={toggleSideMenu}>
                  <HeaderCartIcon />
                  <span className="cart-item">{quantityProduct}</span>
                </li>
              </Link>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
